function SkipToContent({ targetId = "main-content", label = "Sari la conținutul principal" }) {
  return (
    <a
      href={`#${targetId}`}
      style={{
        position: "absolute",
        left: "-9999px",
        top: "0",
        zIndex: 99999,
      }}
      onFocus={(e) => {
        e.currentTarget.style.left = "16px";
        e.currentTarget.style.top = "16px";
      }}
      onBlur={(e) => {
        e.currentTarget.style.left = "-9999px";
        e.currentTarget.style.top = "0";
      }}
      className="skip-to-content"
    >
      <span
        style={{
          display: "inline-block",
          padding: "10px 18px",
          background: "#1565C0",
          color: "#fff",
          fontWeight: 600,
          fontSize: "0.9rem",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
          textDecoration: "none",
        }}
      >
        {label}
      </span>
    </a>
  );
}

import PropTypes from "prop-types";

SkipToContent.propTypes = {
  targetId: PropTypes.string,
  label: PropTypes.string,
};

export default SkipToContent;
